<div>&nbsp;</div>
<div>
  <p-selectButton
    [options]="switchFilterStates"
    (onChange)="onFilter()"
    [(ngModel)]="filterPagingWrapper.filter.statusIds"
  ></p-selectButton>
</div>
<div class="list-container">
  <p-table
    #dt
    [value]="brandingRequestList"
    showGridlines
    [rowHover]="true"
    [lazy]="true"
    [paginator]="true"
    [rows]="pageSize"
    (onLazyLoad)="onLoad($event)"
    [totalRecords]="totalRecords"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>
          <input
            pInputText
            type="text"
            placeholder="{{ 'label.Customer' | translate }}"
            (input)="dt.filter($event.target.value, 'fullName', 'contains')"
          />
        </th>
        <th>
          {{ 'label.Portfolio' | translate }}
        </th>
        <th>
          {{ 'label.AccountManager' | translate }}
        </th>
        <th style="width: 268px">
          {{ 'label.BrandingProducts' | translate }}
        </th>

        <th [pSortableColumn]="'createDate'" style="width: 120px">
          {{ 'label.PurchaseDate' | translate }}
          <p-sortIcon
            [field]="'createDate'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th [pSortableColumn]="'processDate'" style="width: 120px">
          {{ 'label.ActivateDate' | translate }}
          <p-sortIcon
            [field]="'processDate'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th [pSortableColumn]="'tokenExpireDate'" style="width: 120px">
          {{ 'label.ExpireDate' | translate }}
          <p-sortIcon
            [field]="'tokenExpireDate'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th>
          {{ 'label.Action' | translate }}
        </th>
      </tr>
    </ng-template>

    <ng-template
      pTemplate="body"
      let-request
      let-expanded="expanded"
      let-columns="columns"
    >
      <tr>
        <td>
          <span class="customer-view-link"
            ><a [routerLink]="['/customers/view', request.customerId]">{{
              request?.customerName
            }}</a></span
          >
        </td>
        <td>
          <span class="customer-view-link"
            ><a [routerLink]="['/portfolios/view', request.portfolioId]">{{
              request?.portfolioName
            }}</a></span
          >
        </td>
        <td>
          <span>{{ request?.portfolioAccountManagerName }}</span>
        </td>
        <td>
          <span
            class="product-view"
            *ngIf="request.statusId != brandingAccessTokenStatusEnum.Pending"
          >
            {{ request?.storeItem?.product?.name }}
          </span>
          <span
            *ngIf="request.statusId == brandingAccessTokenStatusEnum.Pending"
          >
            <select [(ngModel)]="request.storeItemId">
              <option *ngFor="let item of storeItems" value="{{ item.itemId }}">
                {{ item.product.name }}
              </option>
            </select>
          </span>
        </td>
        <td>
          <span>{{ request.createDate | date : dateFormat }}</span>
        </td>
        <td>
          <span
            *ngIf="request.statusId != brandingAccessTokenStatusEnum.Rejected"
            >{{ request.processDate | date : dateFormat }}</span
          >
        </td>
        <td>
          <span>{{ request.tokenExpireDate | date : dateFormat }}</span>
        </td>
        <td>
          <div class="request-action-link">
            <a
              *ngIf="
                request.statusId === brandingAccessTokenStatusEnum.Pending &&
                hasRequestApproveRejectPermission
              "
              (click)="onApproveRequestClick(request)"
              >{{ 'label.Approve' | translate }}
            </a>
            <a
              *ngIf="
                request.statusId === brandingAccessTokenStatusEnum.Pending &&
                hasRequestApproveRejectPermission
              "
              (click)="onRejectRequestClick(request)"
              >{{ 'label.Reject' | translate }}
            </a>
            <hr-confirm-with-checkbox
              *ngIf="
                request.statusId === brandingAccessTokenStatusEnum.Active &&
                hasRequestTerminationPermission
              "
              [actionName]="'label.Cancel' | translate"
              [checkboxLabel]="'label.AffectBilling' | translate"
              [content]="'label.AreYouSure' | translate"
              [targetId]="request.customerBrandingAccessTokenId"
              [header]="'label.Cancel' | translate"
              (onResult)="onRevokeRequestClick($event)"
            ></hr-confirm-with-checkbox>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- <p-column field="fullName" filterPlaceholder="{{'label.Customer' | translate}}" [filter]="true">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span class="customer-view-link"><a [routerLink]="['/customers/view', request.customerId]">{{request?.customerName}}</a></span>
            </ng-template>
        </p-column>
        <p-column field="portfolioName" header="{{'label.Portfolio' | translate}}">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span class="customer-view-link"><a [routerLink]="['/portfolios/view', request.portfolioId]">{{request?.portfolioName}}</a></span>
            </ng-template>
        </p-column>
        <p-column field="portfolioAccountManagerName" header="{{'label.AccountManager' | translate}}">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span >{{request?.portfolioAccountManagerName}}</span>
            </ng-template>
        </p-column>
        <p-column header="{{'label.BrandingProducts' | translate}}" [style]="{'width': '240px'}">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span class="product-view" *ngIf="request.statusId != brandingAccessTokenStatusEnum.Pending">
                    {{request?.storeItem?.product?.name}}
                </span>
                <span *ngIf="request.statusId == brandingAccessTokenStatusEnum.Pending">
                    <select [(ngModel)]="request.storeItemId">
                        <option *ngFor="let item of storeItems" value="{{item.itemId}}">{{item.product.name}}</option>
                    </select>
                </span>
            </ng-template>
        </p-column>
        <p-column field="createDate" header="{{'label.PurchaseDate' | translate}}" [sortable]="true">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span>{{request[col.field] | date:dateFormat}}</span>
            </ng-template>
        </p-column>
        <p-column field="processDate" header="{{'label.ActivateDate' | translate}}" [sortable]="true">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span *ngIf="request.statusId != brandingAccessTokenStatusEnum.Rejected">{{request[col.field] | date:dateFormat}}</span>
            </ng-template>
        </p-column>
        <p-column field="tokenExpireDate" header="{{'label.ExpireDate' | translate}}" [sortable]="true">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span>{{request[col.field] | date:dateFormat}}</span>
            </ng-template>
        </p-column>
        <p-column header="{{'label.Action' | translate}}">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <div class="request-action-link">
                    <a *ngIf="request.statusId === brandingAccessTokenStatusEnum.Pending && hasRequestApproveRejectPermission" (click)="onApproveRequestClick(request)">{{'label.Approve' | translate}} </a>
                    <a *ngIf="request.statusId === brandingAccessTokenStatusEnum.Pending && hasRequestApproveRejectPermission" (click)="onRejectRequestClick(request)">{{'label.Reject' | translate}} </a>
                    <hr-confirm-with-checkbox *ngIf="request.statusId === brandingAccessTokenStatusEnum.Active && hasRequestTerminationPermission" [actionName]="'label.Cancel' | translate"
                        [checkboxLabel]="'AffectBilling' | translate" [content]="'AreYouSure' | translate"
                        [targetId]=request.customerBrandingAccessTokenId [header]="'Cancel' | translate" (onResult)="onRevokeRequestClick($event)"></hr-confirm-with-checkbox>
                </div>
            </ng-template>
        </p-column> -->
  </p-table>
</div>
